import { Component, OnInit } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';

@Component({
	selector: 'app-proxy-test',
	templateUrl: './proxy-test.component.html',
	standalone: false,
})
export class ProxyTestComponent implements OnInit {
	constructor(private fns: AngularFireFunctions) {}

	ngOnInit(): void {}

	async callHTTPTest() {
		const callable = this.fns.httpsCallable('HTTPTest');
		const result = await callable({ test: 'test value' }).toPromise();
	}
}
